import Game from "../app/game";
import App from "../main";

//SDK //API
export class SDKManager {
    //Configuration from HOST app
    private gameConfig: JSON;

    public insetPadding: any;

    private highestScore: number = 0;

    public get HighestScore(): number {
        return this.highestScore;
    }

    public set HighestScore(value: number) {
        this.highestScore = value;
    }

    public totalAdsWatched: number = 0;

    private totalAdsCount: number = 0;

    private canDebug: boolean = true;

    private hasStarted: boolean = false;

    public canShowInterstitialAd: boolean = true;
    public isTournamentAfterGame: boolean = false;

    public onGameLoading(value: number) {
        // if (FBInstantManager.isFBInstantEnabled == true) {
        //     if (value < 100) {
        //         App.FBInstant.setLoadingProgress(value);
        //     }
        //     if (value >= 100 && !this.hasStarted) {
        //         this.hasStarted = true;
        //         App.FBInstant.setLoadingProgress(100);
        //         App.FBInstant.startGameAsync();
        //     }
        // }

        if (value >= 100 && !this.hasStarted) {
            this.hasStarted = true;
        }
    }

    public async onGameLoad() {
        // if (FBInstantManager.isFBInstantEnabled == true) {
            App.SDK.getDataMeta();
            App.SDK.getDataStars();
            App.SDK.getDataHighScore();
        // }
    }

    public onGameStart() {
        this.debugSDK("On Game Start");
    }

    public onGameRestart(highScore) {
        this.debugSDK("On Game Restart");
        this.totalAdsWatched = 0;
    }

    public onGamePause() {
        this.debugSDK("On Game Paused");
    }

    public onGameResume() {
        this.debugSDK("On Game Resume");
    }

    public onResultScreen(score: number, highScore: number) {
        this.debugSDK("On Game Result Screen");
    }

    public showStickyAds() {
        this.debugSDK("Show Sticky Ads");
    }

    public hideStickyAds() {
        this.debugSDK("Hide Sticky Ads");
    }

    public onGameExit(score, highScore) {
        this.debugSDK("On Game Exit");
    }

    // This method is used to track a custom event for Analytics
    public onTrackEvent(eventName: string, payload: any) {
        this.debugSDK("On Track Event");
    }

    private rewardAdsExistCallback: (boolean) => void;
    // This method is called to check the status of the Rewarded Video Ads  
    public checkRewardedVideoAds(callback: (boolean) => void) {
        this.rewardAdsExistCallback = callback;

        if (this.totalAdsWatched < this.totalAdsCount) {
            this.rewardAdsExistCallback(true);
        } else {
            this.rewardAdsExistCallback(false);
        }
    }

    private rewardAdsExist(args: any) {
        // 0: ad loaded, 1: ad unloaded
        switch (args.status) {
            case 0:
                this.rewardAdsExistCallback(true);
                break;
            default:
                this.rewardAdsExistCallback(false);
                break;
        }
    }

    private onWatchedAddCallback: (boolean) => void;
    // This method is called to show the Rewarded Video Ads  
    public showRewardedVideoAds(autoPlay: number, callback: (boolean) => void) {
        this.onWatchedAddCallback = callback;
        this.debugSDK("Checking reward ad existance");
    }

    private onRewardAds(args: any) {
        // 0: earn rewards, 1: no rewards, 2: ad not loaded, 3: ad failed to show
        switch (args.status) {
            case 0:
                this.totalAdsWatched += 1;
                if (this.onWatchedAddCallback != null)
                    this.onWatchedAddCallback(true);
                break;
            default:
                if (this.onWatchedAddCallback != null)
                    this.onWatchedAddCallback(false);
                break;
        }
    }

    public setBase64Image(value: string) {
        // if (FBInstantManager.isFBInstantEnabled == true) {
        //     FBInstantManager.FBInstantBase64Image = value;
        // }
    }

    public inviteFriend() {
        // if (FBInstantManager.isFBInstantEnabled == true) {
        //     App.FBInstant.inviteFriend();
        // }
    }

    public showBannerAd() {
        // if (FBInstantManager.isFBInstantEnabled == true) {
        //     App.FBInstant.showBannerAd();
        // }
    }

    public sendScore(score: number) {
        // if (FBInstantManager.isFBInstantEnabled == true) {
        //     App.FBInstant.sendScore(score);
        // }
    }

    public shareAsPost(score: number) {
        // if (FBInstantManager.isFBInstantEnabled == true) {
        //     App.FBInstant.shareAsPost(score);
        // }
    }

    public checkForTournament() {
        // if (FBInstantManager.isFBInstantEnabled == true) {
        //     App.FBInstant.checkForTournament();
        // }
    }

    public createTournament(score: number = 0) {
        // if (FBInstantManager.isFBInstantEnabled == true) {
        //     App.FBInstant.createTournament(score);
        // }
    }

    public playerLeaderboardEntry() {
        // if (FBInstantManager.isFBInstantEnabled == true) {
        //     return App.FBInstant.playerLeaderboardEntry;
        // }
        return null;
    }

    public getDataHighScore() {
        // App.SDK.HighestScore = 0;
        // Game.instance.proceedLoadStage();
        // return null;

        // FBInstant.player
        //     .getDataAsync(["highscore"])
        //     .then(function (data) {
        //         if (data["highscore"] == null) {
        //             // data["highscore"] = 0;
        //             App.SDK.setDataHighScore(0);
        //             App.SDK.HighestScore = 0;
        //         } else {
        //             App.SDK.HighestScore = data["highscore"];
        //         }
        //         Game.instance.proceedLoadStage();
        //     })
        //     .catch(function() {
        //         App.SDK.HighestScore = 0;
        //         Game.instance.proceedLoadStage();
        //     });

        App.SDK.HighestScore = +localStorage.getItem('hammerplay_doodledrop_highscore');
        if (App.SDK.HighestScore == 0 || null) {
            App.SDK.HighestScore = 0;
            localStorage.setItem('hammerplay_doodledrop_highscore', App.SDK.HighestScore.toString());
        }
        Game.instance.proceedLoadStage();
    }

    public setDataHighScore(value: number) {
        // FBInstant.player
        //     .setDataAsync({
        //         highscore: value,
        //     });

        localStorage.setItem('hammerplay_doodledrop_highscore', value.toString());
    }

    public getDataStars() {
        // App.stars = 0;
        // Game.instance.proceedLoadStage();
        // return null;

        // FBInstant.player
        //     .getDataAsync(["stars"])
        //     .then(function (data) {
        //         if (data["stars"] == null) {
        //             // data["stars"] = 0;
        //             App.SDK.setDataStars(0);
        //             App.stars = 0;
        //         } else {
        //             // data["stars"] = 15000;
        //             // App.SDK.setDataStars(data["stars"]);
        //             App.stars = data["stars"];
        //         }
        //         Game.instance.proceedLoadStage();
        //     })
        //     .catch(function() {
        //         App.stars = 0;
        //         Game.instance.proceedLoadStage();
        //     });

        App.stars = +localStorage.getItem('hammerplay_doodledrop_stars');
        if (App.stars == 0 || null) {
            App.stars = 0;
            localStorage.setItem('hammerplay_doodledrop_stars', App.stars.toString());
        }
        Game.instance.proceedLoadStage();
    }

    public setDataStars(value: number) {
        // FBInstant.player
        //     .setDataAsync({
        //         stars: value,
        //     });

        localStorage.setItem('hammerplay_doodledrop_stars', value.toString());
    }

    public getDataMeta() {
        // App.meta = App.metaInitial;
        // Game.instance.proceedLoadStage();
        // return null;

        // FBInstant.player
        //     .getDataAsync(["meta"])
        //     .then(function (data) {
        //         if (data["meta"] == null) {
        //             // data["meta"] = App.metaInitial;
        //             App.SDK.setDataMeta(App.metaInitial);
        //             App.meta = App.metaInitial;
        //         } else {
        //             // data["meta"] = App.metaInitial;
        //             // App.SDK.setDataMeta(data["meta"]);
        //             App.meta = data["meta"];
        //         }
        //         Game.instance.proceedLoadStage();
        //     })
        //     .catch(function() {
        //         App.meta = App.metaInitial;
        //         Game.instance.proceedLoadStage();
        //     });

        App.meta = localStorage.getItem('hammerplay_doodledrop_meta');
        if (App.meta == null || undefined) {
            App.meta = App.metaInitial;
            localStorage.setItem('hammerplay_doodledrop_meta', JSON.stringify(App.meta));
            App.meta = JSON.parse(localStorage.getItem('hammerplay_doodledrop_meta'));
            App.characterIndex = 0;
        }
        else {
            App.meta = JSON.parse(localStorage.getItem('hammerplay_doodledrop_meta'));
        }
        Game.instance.proceedLoadStage();
    }

    public setDataMeta(value: any) {
        // FBInstant.player
        //     .setDataAsync({
        //         meta: value,
        //     });

        localStorage.setItem('hammerplay_doodledrop_meta', JSON.stringify(value));
    }

    public async loadInterstitialAd() {
        // if (FBInstantManager.isFBInstantEnabled) {
        //     App.FBInstant.loadInterstitialAd();
        // }
    }

    public async watchRewardAd(type: string, callback: (value: boolean) => void) {
        // if (FBInstantManager.isFBInstantEnabled) {
        //     try {
        //         let videoAdID: string = App.FBInstant.videoAdID1;
        //         if (type == 'stars') {
        //             videoAdID = App.FBInstant.videoAdID2;
        //         }
        //         else if (type == 'life') {
        //             videoAdID = App.FBInstant.videoAdID1;
        //         }
        //         let result = await App.FBInstant.showVideoAd(videoAdID);
        //         if (result == null || typeof result == 'undefined') {
        //             result = false;
        //         }
        //         callback(result);
        //     }
        //     catch (error) {
        //         callback(false);
        //     }
        // }
        // else {
        //     callback(false);
        // }
        callback(true); // Proxy Code. Remove Later.
    }

    public async watchInterstitialAd(callback: (value: boolean) => void) {
        // if (FBInstantManager.isFBInstantEnabled) {
        //     try {
        //         let result = await App.FBInstant.showInterstitialAd();
        //         if (result == null || typeof result == 'undefined') {
        //             result = false;
        //         }
        //         callback(result);
        //     }
        //     catch (error) {
        //         callback(false);
        //     }
        // }
        // else {
        //     callback(false);
        // }
        callback(true); // Proxy Code. Remove Later.
    }

    private debugSDK(message: string) {
        if (this.canDebug)
            console.log(message)
    }
}
